import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { QueryOptions } from "../../../types/QueryOptions";
import { fetchUser, User } from "./fetchUser";

export const userQuery = (): QueryOptions<User | null> => ({
  queryKey: queryKeys.user.mine,
  queryFn: fetchUser,
  staleTime: STALE_TIME_L,
});
